import React from 'react';
import { DecoratorNode, NodeKey } from 'lexical';
import GoogleAd from '../../GoogleAds';

export class AdNode extends DecoratorNode<JSX.Element> {
  __adClient: string;
  __adSlot: string;
  __interactionObjectId: string;

  static getType(): string {
    return 'ad';
  }

  static clone(node: AdNode): AdNode {
    return new AdNode(node.__adClient, node.__adSlot, node.__interactionObjectId, node.__key);
  }

  constructor(adClient: string, adSlot: string, interactionObjectId: string, key?: NodeKey) {
    super(key);
    this.__adClient = adClient;
    this.__adSlot = adSlot;
    this.__interactionObjectId = interactionObjectId;
  }

  createDOM(): HTMLElement {
    const div = document.createElement('div');
    div.className = 'ad-node';
    return div;
  }

  updateDOM(): boolean {
    return false;
  }

  decorate(): JSX.Element {
    return (
      <GoogleAd
        articleId={this.__interactionObjectId}
        slot={this.__adSlot}
        format="fluid"
        adLayout="in-article"
        textAlign="center"
        className="ad-node my-custom-ad !z-10"
      />
    );
  }

  static importJSON(serializedNode: any): AdNode {
    const { adClient, adSlot, interactionObjectId } = serializedNode;
    return new AdNode(adClient, adSlot, interactionObjectId);
  }

  // Implement exportJSON method for serialization
  exportJSON(): any {
    return {
      type: 'ad',
      version: 1,
      adClient: this.__adClient,
      adSlot: this.__adSlot
    };
  }
}

export function $createAdNode(
  adClient: string,
  adSlot: string,
  interactionObjectId: string
): AdNode {
  return new AdNode(adClient, adSlot, interactionObjectId);
}
